module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAV0lEQVQoU2NkIBIwIqv7////fwYGhkaoWD0jIyNcnhEqSdBckMIGkCpGRkYwjQ7g8jAGAwPDARzGOoANQlKI1/ohpZCY4ElgYGCIZ2BgOIjD2/YMDAwLASeUM06BLekSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trash.png
// module id = HVb9
// module chunks = 2